exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar--2UQpp {\n  position: relative;\n  border-radius: 50%;\n  border: 2px solid steelblue;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center; }\n\n.avatarOnlineStatus--3XDRh {\n  position: absolute;\n  bottom: -3px;\n  right: -3px; }\n\n.onlineStatus--mi_wA {\n  display: inline-block;\n  background: white;\n  border-radius: 50%;\n  border: 1px solid white; }\n  .onlineStatus--mi_wA.online--17lbe {\n    background-color: #2ecc71; }\n  .onlineStatus--mi_wA.connectionProblem--1CEtI {\n    width: 13px;\n    height: 13px;\n    color: #e64c3b; }\n  .onlineStatus--mi_wA.offline--15Txg {\n    background-color: #e64c3b; }\n", ""]);

// exports
exports.locals = {
	"avatar": "avatar--2UQpp",
	"avatarOnlineStatus": "avatarOnlineStatus--3XDRh",
	"onlineStatus": "onlineStatus--mi_wA",
	"online": "online--17lbe",
	"connectionProblem": "connectionProblem--1CEtI",
	"offline": "offline--15Txg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[local]--[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/Avatar/Avatar.scss
// module id = 594
// module chunks = 4